export function validateFormData(formData) {
  // Regular expression for email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const firstNameLastNameRegex = /^[a-zA-Z'-\s]+$/;

  // Regular expression for USA and Canada postal codes validation
  const postalCodeRegex = /(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)|(^[a-z0-9]{6}$)/i;

  // Helper function to validate PostalCode text fields
  const validatePostalCode = (value) => {
    const clearValue = value.replace(/\s/g, "");
    return postalCodeRegex.test(clearValue.trim());
  };

  // Helper function to validate FirstName LastName
  // text fields on the NTD contact form
  const validateFirstNameLastName = (value) => {
    return firstNameLastNameRegex.test(value.trim());
  };

  // Helper function to validate email fields
  const validateEmail = (value) => emailRegex.test(value);

  // Initialize validation result object
  let validationResult = { ...formData };

  // Check each field in formData
  for (let key in formData) {
    const { value, type } = formData[key];
    switch (type) {
      case "text":
        if (!value && key !== "postal_code" && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is required",
          };
        } else if (
          value &&
          key === "postal_code" &&
          !validatePostalCode(value)
        ) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is not correct postal code !!!",
          };
        } else if (
          value &&
          ["first_name", "last_name"].includes(key) &&
          !validateFirstNameLastName(value)
        ) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message:
              "This field is not correct (only letters, spaces, hyphens and apostrophes are allowed)",
          };
        } else if (
          !!value &&
          value !== "" &&
          formData[key]?.validation?.length > 0
        ) {
          let isValid = true;
          let message = "";
          for (let i = 0; i < formData[key].validation.length; i++) {
            const rule = formData[key].validation[i];
            switch (rule.type) {
              case "Maximum length":
                if (value.length > Number(rule.value)) {
                  isValid = false;
                  message =
                    rule.ErrorMessage ||
                    "The length must be less than " + rule.value + ".";
                }
                break;
              case "Minimum length":
                if (value.length <= Number(rule.value)) {
                  isValid = false;
                  message =
                    rule.ErrorMessage ||
                    "The length must be greater than or equal to " +
                      rule.value +
                      ".";
                }
                break;
              case "Maximum value":
                if (isNaN(value) || Number(value) > Number(rule.value)) {
                  isValid = false;
                  message =
                    rule.ErrorMessage ||
                    "The value must be less than " + rule.value + ".";
                }
                break;
              case "Minimum value":
                if (isNaN(value) || Number(value) <= Number(rule.value)) {
                  isValid = false;
                  message =
                    rule.ErrorMessage ||
                    "The value must be greater than or equal to " +
                      rule.value +
                      ".";
                }
                break;
              case "Regular expression":
                if (!new RegExp(rule.value).test(value)) {
                  isValid = false;
                  message = rule.ErrorMessage || "The input is not valid.";
                }
                break;
              default:
            }
            if (!isValid) break;
          }
          validationResult[key] = {
            ...formData[key],
            valid: isValid,
            message: isValid ? "" : message,
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: "",
          };
        }
        break;
      case "email":
        if (!value && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is required",
          };
        } else if (!validateEmail(value) && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "Please enter a valid email address",
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: "",
          };
        }
        break;
      case "checkbox":
        if ((!value || value.length === 0) && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: `${
              ["top_questions", "terms_of_use"].includes(key)
                ? formData[key].message
                : "This field is required"
            }`,
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: `${
              ["top_questions", "terms_of_use"].includes(key)
                ? formData[key].message
                : ""
            }`,
          };
        }
        break;
      case "radio":
        if (!value && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is required",
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: "",
          };
        }
        break;
      case "textarea":
        const regex = /^\s+$/g;
        if (formData[key].required && (!value || value.match(regex))) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is required",
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            value: value,
            valid: true,
            message: "",
          };
        }
        break;
      case "select":
        if (!value && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is required",
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: "",
          };
        }
        break;
      case "recaptcha":
        if (!value && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "Please enter Captcha in order to proceed.",
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: "",
          };
        }
        break;
      case "signature":
        if (!value && formData[key].required) {
          validationResult[key] = {
            ...formData[key],
            valid: false,
            message: "This field is required",
          };
        } else {
          validationResult[key] = {
            ...formData[key],
            valid: true,
            message: "",
          };
        }
        break;
      default:
    }
  }

  // Check if email and email_confirm fields match
  if (
    formData?.email &&
    formData?.email_confirm &&
    formData?.email?.value !== formData?.email_confirm?.value
  ) {
    validationResult.email_confirm = {
      ...formData.email_confirm,
      valid: false,
      message: "Email and email confirmation must match",
    };
  }

  return validationResult;
}
